import {getTipList} from "../../../helpers/tip_helper";

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const fetchUserTips = createAsyncThunk(
  'tips/fetchUserTips',
  async (_, { rejectWithValue }) => {
    try {
      return await getTipList();
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to fetch tips');
    }
  }
);
